import { createContext } from 'react'

type State = {
  isReloadable: boolean
  shouldUpdate: boolean
  version: string
}

type Actions = {
  setIsReloadable: (isReloadable: boolean) => void
}

export type Context = State & Actions

export const defaultValue = {
  isReloadable: false,
  shouldUpdate: false,
  version: '',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setIsReloadable: (isReloadable: boolean): void => {},
}

/**
 * @deprecated: do not use this context but instead use our `VersionProvider`
 * or `useVersion` when you need to display your version
 *
 * it seems some apps/component dont use our useVersion but instead creating their own context...
 * **should only be used for unit tests, nothing else!**
 * */
export const VersionContext: React.Context<Context> = createContext<Context>(defaultValue)
